
import { Component, Vue } from "nuxt-property-decorator";
import CardCarousel from "~/components/shared/CardCarousel.vue";
import { pelletsGuideCards } from "~/defaults/pellets/pelletsGuideCards";
import { PelletsGuideCard } from "~/types/Pellets";

@Component({
  components: {
    CardCarousel,
  },
})
export default class PelletsGuideCarousel extends Vue {
  cards: PelletsGuideCard[] = pelletsGuideCards;
}
